import React from 'react';
import InputText from "./InputText.jsx";
import * as constants from "../constants/constants.jsx";
import LegalEntityFunctions from "./LegalEntityFunctions.jsx";
import {
  generatePersonalCodePlaceholder,
  getPersonalCodeMaxLength,
  createPersonalCodeChangeHandler
} from "../../utils/personalCodeFormatter.js";

export function PersonalCodeInput({
  personalCode,
  onPersonalCodeChange,
  legalEntityId,
  id = "personalCode",
  prop = "personalCode"
}) {
  const entityId = legalEntityId || LegalEntityFunctions.getLegalEntityId(localStorage.getItem(constants.SELECTED_COUNTRY));
  const personalCodeMaxLength = getPersonalCodeMaxLength(entityId);
  const handlePersonalCodeChange = createPersonalCodeChangeHandler(onPersonalCodeChange, entityId);

  return (
    <div className="form-field-container">
      <InputText
        id={id}
        prop={prop}
        value={personalCode}
        onChange={handlePersonalCodeChange}
        maxLength={personalCodeMaxLength}
        placeholder={generatePersonalCodePlaceholder(entityId)}
      />
    </div>
  );
}

export default PersonalCodeInput; 